export default class ITShowcaseEvent {
    id;
    title;
    status;
    description;
    bannerUrl;
    createdAt;
    enableVoting;
    enableLocalStation;
    localVotingStation = {};
    arImageTargets = [];

    constructor(title, description, bannerUrl, createdAt, status, id) {
        this.title = title;
        this.description = description;
        this.bannerUrl = bannerUrl;
        this.createdAt = createdAt;
        this.status = status;
        this.id = id;
    }

    setEnableVoting(enableVoting) {
        this.enableVoting = enableVoting || false;
    }

    setEnableLocalStation(enableLocalStation) {
        this.enableLocalStation = enableLocalStation || false;
    }

    setLocalVotingStation(localVotingStation) {
        this.localVotingStation = localVotingStation;
    }

    setARImageTargets(arImageTargets = []) {
        this.arImageTargets = arImageTargets;
        for (const arImageTarget of this.arImageTargets) {
            const arContent = arImageTarget.arContent || {};
            arContent.config = JSON.parse(arContent.config || '{}');
        }
    }
}